<!--
   Created by qing on 2020/12/30
   Des:
-->
<template>
  <div class="ry-home-config-container">
    <header v-if="showHeader">
      <span v-if="showTitle">{{current.title}}</span>
      <div class="chart-header__slot">
        <slot name="header"></slot>
      </div>
      <template v-if="type === CONFIG_STATUS_TYPE__EDIT">
        <div
          class="chart-handle__container"
          v-show="current.isHover">
          <el-button
            icon="el-icon-edit"
            @click.left="current.edit"
            title="编辑"
            type="text">
          </el-button>
          <el-button
            icon="el-icon-delete"
            @click.left="current.remove"
            title="删除"
            type="text">
          </el-button>
        </div>
      </template>
      <template v-if="false">
        <div
          class="chart-handle__container"
          v-show="current.isHover">
          <el-button
            v-if="current.getValue"
            type="text"
            title="刷新"
            @click.left="current.getValue"
            icon="el-icon-refresh">
          </el-button>
        </div>
      </template>
    </header>
    <section :style="{top: showHeader ? '40px' : '0'}">
      <slot></slot>
    </section>
  </div>
</template>

<script>
  import {
    CONFIG_TYPE__TODO,
    CONFIG_STATUS_TYPE__EDIT,
    CONFIG_STATUS_TYPE__VIEW, CONFIG_TYPE__DASHBOARD, CONFIG_TYPE__CONTACT_ME
  } from "../../type";

  export default {
    props: {
      value: Object,
      type: Number,
      isPhone: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        CONFIG_TYPE__TODO,
        CONFIG_TYPE__DASHBOARD,
        CONFIG_STATUS_TYPE__EDIT,
        CONFIG_STATUS_TYPE__VIEW,
        current: this.value,
      }
    },
    computed: {
      showTitle() {
        return true
      },
      showHeader() {
        return this.current.configType !== CONFIG_TYPE__TODO &&
          this.current.configType !== CONFIG_TYPE__DASHBOARD&&
          this.current.configType !== CONFIG_TYPE__CONTACT_ME
      }
    },
    created() {
    },
    methods: {
    }
  }
</script>

<style lang="less">
  .ry-home-config-container {
    width: 100%;
    height: 100%;
    position: relative;

    > header {
      height: 40px;
      padding: 0 12px;
      font-size: 0;
      line-height: 0;

      > span {
        line-height: 40px;
        font-size: 14px;
        color: #1f2d3d;
        font-weight: 700;
        float: left;
      }

      >.chart-header__slot {
        display: inline-block;
        height: 40px;
        width: auto;
        padding-left: 5px;
        float: left;
        z-index: 1;
      }

      > .chart-handle__container {
        position: relative;
        float: right;
        z-index: 4;
        .el-button {
          margin: 0;
          padding-right: 6px;
          padding-left: 6px;
        }
      }
    }

    > section {
      position: absolute;
      top: 40px;
      left: 0;
      right: 0;
      overflow: auto;
      bottom: 0;
    }

    > .ry-form__chart-container-placeholder {
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      position: absolute;
      z-index: 4;

      .ry-home__item-button-list {
        position: absolute;
        top: -10px;
        right: 0;
        padding: 0 6px 6px 6px;
        cursor: pointer;

        .ry-home__item-button {
          width: 30px;
          height: 30px;
          display: none;
          margin: 0 0 0 5px;
          border-radius: 50%;

          &:hover {
          }
        }
      }

      &:hover {
        .ry-home__item-button {
          display: inline-block;
        }
      }
    }
  }
</style>
